export default __webpack_public_path__ + "static/media/enviroment.b9f2a734.png";